import { appConstants } from "./constants";

/**
 * Hashmap used as a look up of concept name to dynamically render friendly named '.svgs'
 */
export const conceptMap = new Map([
  [10, "babyshop"],
  [17, "shoeexpress"],
  [20, "shoemart"],
  [21, "centrepoint"],
  [29, "homebox"],
  [30, "splash"],
  [34, "shoemartinternational"],
  [39, "splash"],
  [40, "homecentre"],
  [50, "lifestyle"],
  [60, "max"],
]);

/**
 * Hashmap used as a look up of App Id to dynamically Navigate to App Store
 */
export const appStoreUrlMap = new Map([
  [10, 1161312755],
  [17, 1161310479],
  [20, 1161310479],
  [21, 1161310479],
  [29, 1262975833],
  [30, 1157403562],
  [39, 1157403562],
  [40, 1161311546],
  [50, 1161310479],
  [60, 1161312751],
]);

/**
 * Hashmap used as a look up of App Id to dynamically Navigate to Play Store
 */
export const playStoreUrlMap = new Map([
  [10, "babyshopstores"],
  [17, "centrepointstores"],
  [20, "centrepointstores"],
  [21, "centrepointstores"],
  [29, "homeboxstores"],
  [30, "splashfashions"],
  [39, "splashfashions"],
  [40, "homecentrestores"],
  [50, "lifestyle"],
  [60, "maxstores"],
]);

/**
 * Hashmap used as a look up of Web URL to dynamically Navigate to Web Page
 */
export const webUrlMap = new Map([
  [10, appConstants.babyshopWeb],
  [17, appConstants.shoeexpressWeb],
  [20, appConstants.shoemartWeb],
  [21, appConstants.centrepointWeb],
  [29, appConstants.homeboxWeb],
  [30, appConstants.splashWeb],
  [39, appConstants.splashWeb],
  [34, appConstants.shoemartinternationalWeb],
  [40, appConstants.homecentreWeb],
  [50, appConstants.lifestyleWeb],
  [60, appConstants.maxWeb],
]);
